var $, Accordion, AnimBg, AnimTitle, ChangeBg, DisableSendBtn, Footer, Header, Index, InitPc, InitSp, Load, ReplaceImg, Slider, TabChange, Transition, Video, ZipInput, _device, _sp, _ua, _wh, _ww, easeljs, preloadjs,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

$ = window.jQuery = require('./lib/jquery.min');

require('./lib/jquery.pjax.min');

require('./lib/jquery.easing.min');

require('./lib/velocity.min');

require('./lib/TweenMax.min');

easeljs = require('easeljs');

preloadjs = require('preloadjs');

_ua = navigator.userAgent;

_sp = _ua.indexOf('iPhone') > -1 || _ua.indexOf('iPod') > -1 || _ua.indexOf('Android') > -1;

if (_sp) {
  _device = 'sp';
} else {
  _device = 'pc';
}

_ww = $(window).width();

_wh = $(window).height();

$(window).on('resize', (function(_this) {
  return function() {
    _ww = $(window).width();
    return _wh = $(window).height();
  };
})(this));

ReplaceImg = (function() {
  function ReplaceImg() {
    if (!_sp) {
      this.device = "pc";
    } else {
      this.device = "sp";
    }
  }

  ReplaceImg.prototype.replace = function(src) {
    src = src.replace("device", this.device);
    return src;
  };

  ReplaceImg.prototype.set = function($target, func1) {
    var _this;
    this.$target = $target;
    this.func = func1;
    _this = this;
    return this.$target.each(function(i) {
      if ($(this).data("src") != null) {
        if (($(this).data("device") == null) || $(this).data("device") === _this.device) {
          $(this).attr("src", _this.replace($(this).data("src")));
        }
      }
      if (i === _this.$target.length - 1) {
        if (_this.func != null) {
          return _this.func();
        }
      }
    });
  };

  return ReplaceImg;

})();

Load = (function() {
  function Load() {
    this.initComp = bind(this.initComp, this);
    this.comp = bind(this.comp, this);
    this.anim = bind(this.anim, this);
    this.load = bind(this.load, this);
    this.searchImgSrc = bind(this.searchImgSrc, this);
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    this.replaceImg = new ReplaceImg;
  }

  Load.prototype.searchImgSrc = function($img) {
    var _this, imgs;
    _this = this;
    imgs = [];
    $img.each(function() {
      if ($(this).is('img')) {
        if ($(this).attr('src') != null) {
          imgs.push($(this).attr('src'));
        }
        if ($(this).attr('data-src') != null) {
          return imgs.push(_this.replaceImg.replace($(this).attr('data-src')));
        }
      } else if ($(this).css('background-image') !== 'none') {
        return imgs.push($(this).css('background-image').replace(/(url\(|\)|")/g, ''));
      } else if ($(this).attr('data-bg-src') != null) {
        return imgs.push(_this.replaceImg.replace($(this).attr('data-bg-src')));
      }
    });
    return imgs;
  };

  Load.prototype.load = function(imgs, func) {
    var isLoad, loadQueue, manifest;
    if (imgs != null) {
      this.$lLoader.css({
        'display': 'block'
      });
      manifest = imgs;
      isLoad = false;
      loadQueue = new createjs.LoadQueue(true);
      loadQueue.addEventListener('progress', (function(_this) {
        return function(event) {
          var prog;
          prog = Math.round(event.progress * 50) + 50;
          return _this.anim(prog);
        };
      })(this));
      loadQueue.addEventListener('complete', (function(_this) {
        return function() {
          if ((func != null) && !isLoad) {
            func();
            _this.comp();
            return isLoad = true;
          }
        };
      })(this));
      loadQueue.loadManifest(manifest);
      return setTimeout((function(_this) {
        return function() {
          if ((func != null) && !isLoad) {
            func();
            _this.comp();
            return isLoad = true;
          }
        };
      })(this), 10000);
    } else {
      if ((func != null) && !isLoad) {
        func();
        return isLoad = true;
      }
    }
  };

  Load.prototype.anim = function(prog) {
    return this.$loaderProg.stop().velocity('stop').velocity({
      'width': [prog + "%", 'linear']
    }, 125);
  };

  Load.prototype.comp = function() {
    return this.$loaderProg.stop().velocity('stop').css({
      'width': '100%',
      'left': 'auto',
      'right': 0
    }).velocity({
      'width': ['0%', 'easeInOutExpo']
    }, 750, (function(_this) {
      return function() {
        _this.$lLoader.css({
          'display': 'none'
        });
        return _this.$loaderProg.css({
          'left': 0,
          'right': 'auto'
        });
      };
    })(this));
  };

  Load.prototype.initComp = function() {
    return this.$loaderBg.velocity({
      'opacity': [0, 'easeOutCubic']
    }, 500);
  };

  return Load;

})();

Accordion = (function() {
  function Accordion($button) {
    this.close = bind(this.close, this);
    this.open = bind(this.open, this);
    this.$button = $button;
    this.isAnimate = false;
    this.set();
  }

  Accordion.prototype.set = function() {
    var _this;
    _this = this;
    return this.$button.each(function() {
      return $(this).on('click', function() {
        var id;
        if (!_this.isAnimate) {
          _this.isAnimate = true;
          id = $(this).closest('.m-accordion').data('accordion');
          if (!id) {
            id = '_self';
          }
          if (!$(this).closest('.m-accordion').hasClass('is-open')) {
            return _this.open($(this), id);
          } else {
            return _this.close($(this), id);
          }
        }
      });
    });
  };

  Accordion.prototype.open = function($button, id) {
    var $detail, h;
    $button.closest('.m-accordion').addClass('is-open');
    if (id === '_self') {
      return this.isAnimate = false;
    } else {
      $detail = $(".m-accordion-detail[data-accordion='" + id + "']");
      $detail.css({
        'display': 'block'
      });
      h = $detail.height();
      return $detail.css({
        'height': 0,
        'overflow': 'hidden'
      }).velocity({
        'height': h
      }, 375, 'easeOutCubic', (function(_this) {
        return function() {
          return _this.isAnimate = false;
        };
      })(this));
    }
  };

  Accordion.prototype.close = function($button, id) {
    var $detail, h;
    $button.closest('.m-accordion').removeClass('is-open');
    if (id === '_self') {
      this.isAnimate = false;
    } else {
      $detail = $(".m-accordion-detail[data-accordion='" + id + "']");
      h = $detail.height();
      $detail.velocity({
        'height': 0
      }, 375, 'easeOutCubic', (function(_this) {
        return function() {
          _this.isAnimate = false;
          return $detail.css({
            'display': 'none',
            'height': 'auto'
          });
        };
      })(this));
    }
    if ($button.closest('.m-accordion').find('.m-slide-container').width() > 0) {
      this.slider = new Slider;
      return this.slider.reset($button.closest('.m-accordion').find('.m-slide-container'));
    }
  };

  return Accordion;

})();

TabChange = (function() {
  function TabChange() {
    this.change = bind(this.change, this);
    this.$tabContainer = $('.m-tab-container');
    this.$tabTrigger = this.$tabContainer.find('.m-tab-navigation li');
    this.set();
  }

  TabChange.prototype.set = function() {
    var _this;
    _this = this;
    this.$tabContainer.each(function() {
      var tabTarget, targetId;
      $(this).find('.m-tab-navigation li').first().addClass('is-current');
      targetId = $(this).find('.m-tab-navigation li.is-current').data('target-id');
      tabTarget = $(this).find('[data-tab-id="' + targetId + '"]');
      return tabTarget.addClass('is-selected');
    });
    return this.$tabTrigger.on('click', function() {
      var tabTarget, targetId;
      targetId = $(this).data('target-id');
      this.$tabContainer = $(this).closest('.m-tab-container');
      tabTarget = this.$tabContainer.find('[data-tab-id="' + targetId + '"]');
      return _this.change($(this), tabTarget);
    });
  };

  TabChange.prototype.change = function(tabTrigger, tabTarget) {
    var tabList;
    this.$tabContainer = tabTrigger.closest('.m-tab-container');
    tabList = this.$tabContainer.find('>.m-tab-navigation li');
    tabList.removeClass('is-current');
    tabTrigger.addClass('is-current');
    this.$tabContainer.find('.is-selected').hide();
    this.$tabContainer.find('.m-tab-content').removeClass('is-selected');
    tabTarget.css({
      'display': 'block',
      'opacity': 0
    }).stop(true, true).animate({
      'opacity': 1
    }, 800, 'easeOutCubic');
    return tabTarget.addClass('is-selected');
  };

  return TabChange;

})();

Slider = (function() {
  function Slider() {
    this.move = bind(this.move, this);
    this.$slideContainer = $('.m-slide-container');
    this.$slideTrigger = $('.m-slide-nav .prev, .m-slide-nav .next');
    this.isAnimate = false;
  }

  Slider.prototype.set = function() {
    var _this;
    _this = this;
    this.$slideContainer.each(function() {
      var i, k, ref, slideLength, slideMargin, slideParent, slideWidth;
      slideParent = $(this).find('.slide-parent');
      slideWidth = $(this).width();
      slideLength = slideParent.find('.slide').length;
      slideMargin = 20;
      slideParent.find('.slide').first().addClass('is-current');
      $(this).find('.m-slide-nav .prev').addClass('is-disable');
      slideParent.width(slideWidth * slideLength + slideMargin * (slideLength - 1));
      slideParent.find('.slide').width(slideWidth);
      for (i = k = 0, ref = slideLength - 1; 0 <= ref ? k <= ref : k >= ref; i = 0 <= ref ? ++k : --k) {
        $(this).find('.m-slide-nav').append('<li class="page"></li>');
      }
      $(this).find('.m-slide-nav').append($(this).find('.m-slide-nav .next'));
      return $(this).find('.m-slide-nav .page').first().addClass('is-current');
    });
    return this.$slideTrigger.on('click', function() {
      if (!_this.isAnimate) {
        _this.isAnimate = true;
        if ($(this).hasClass('prev') && !$(this).hasClass('is-disable')) {
          return _this.move($(this), 'right');
        } else if ($(this).hasClass('next') && !$(this).hasClass('is-disable')) {
          return _this.move($(this), 'left');
        }
      }
    });
  };

  Slider.prototype.reset = function(slideTargetContainer) {
    slideTargetContainer.find('.slide-parent').velocity({
      'margin-left': 0
    }, 600, 'easeOutCubic', (function(_this) {
      return function() {
        return _this.isAnimate = false;
      };
    })(this));
    slideTargetContainer.find('.slide').removeClass('is-current');
    slideTargetContainer.find('.slide').first().addClass('is-current');
    slideTargetContainer.find('.m-slide-nav .page').removeClass('is-current');
    slideTargetContainer.find('.m-slide-nav .page').first().addClass('is-current');
    slideTargetContainer.find('.m-slide-nav .is-disable').removeClass('is-disable');
    return slideTargetContainer.find('.m-slide-nav .prev').addClass('is-disable');
  };

  Slider.prototype.move = function(slideNav, direction) {
    var slideCount, slideCurrent, slideCurrentNo, slideLength, slideMargin, slideNavCurrent, slideParent, slideTarget, slideTargetContainer, slideWidth;
    slideTargetContainer = slideNav.closest('.m-slide-container');
    slideParent = slideTargetContainer.find('.slide-parent');
    slideTarget = slideParent.find('.slide');
    slideCurrent = slideParent.find('.slide.is-current');
    slideNavCurrent = slideTargetContainer.find('.m-slide-nav .page.is-current');
    slideWidth = slideTarget.first().width();
    slideLength = slideTarget.length;
    slideCurrentNo = slideTarget.index(slideCurrent) + 1;
    slideMargin = 20;
    slideNavCurrent.removeClass('is-current');
    if (direction === 'left') {
      slideCount = slideCurrentNo;
      slideNavCurrent.next().addClass('is-current');
    } else if (direction === 'right') {
      slideCount = slideCurrentNo - 2;
      slideNavCurrent.prev().addClass('is-current');
    }
    slideTargetContainer.find('.m-slide-nav .is-disable').removeClass('is-disable');
    if (direction === 'left' && slideCurrentNo === slideLength - 1) {
      slideTargetContainer.find('.m-slide-nav .next').addClass('is-disable');
    }
    if (direction === 'right' && slideCurrentNo === 2) {
      slideTargetContainer.find('.m-slide-nav .prev').addClass('is-disable');
    }
    return slideParent.velocity({
      'margin-left': -(slideWidth + slideMargin) * slideCount
    }, 800, 'easeOutCubic', (function(_this) {
      return function() {
        _this.isAnimate = false;
        slideTarget.removeClass('is-current');
        if (direction === 'left') {
          return slideCurrent.next().addClass('is-current');
        } else if (direction === 'right') {
          return slideCurrent.prev().addClass('is-current');
        }
      };
    })(this));
  };

  return Slider;

})();

ZipInput = (function() {
  function ZipInput() {
    this.set();
  }

  ZipInput.prototype.set = function() {
    return $("#btn-address").on('click', function(e) {
      AjaxZip3.zip2addr('zip', '', 'address_1', 'address_2', 'address_3');
      return false;
    });
  };

  return ZipInput;

})();

DisableSendBtn = (function() {
  function DisableSendBtn() {
    this.set();
  }

  DisableSendBtn.prototype.set = function() {
    return $("#complete-send-btn").on('click', function(e) {
      e.preventDefault();
      $(this).attr('disabled', 'disabled');
      $(this).addClass('is-disable');
      return $(this).closest('form').submit();
    });
  };

  return DisableSendBtn;

})();

Video = (function() {
  function Video($canvas, src, width, height) {
    this.play = bind(this.play, this);
    var canvas, data, spriteSheet;
    canvas = $canvas.get(0);
    this.stage = new createjs.Stage(canvas);
    $(canvas).attr('width', width);
    $(canvas).attr('height', height);
    data = {
      images: src,
      frames: {
        width: width,
        height: height,
        regX: 0,
        regY: 0
      },
      animations: {
        show: [0, 35, false, 1]
      }
    };
    spriteSheet = new createjs.SpriteSheet(data);
    this.sprite = new createjs.Sprite(spriteSheet);
    this.sprite.x = 0;
    this.sprite.y = 0;
    this.stage.addChild(this.sprite);
  }

  Video.prototype.play = function() {
    this.sprite.gotoAndPlay('show');
    this.stage.update();
    createjs.Ticker.setFPS(24);
    return createjs.Ticker.addEventListener('tick', this.stage);
  };

  return Video;

})();

AnimBg = (function() {
  function AnimBg() {
    this.hideEnd = bind(this.hideEnd, this);
    this.hideStart = bind(this.hideStart, this);
    this.show = bind(this.show, this);
    this.set = bind(this.set, this);
    this.$lBg = $('.l-bg');
    this.$bg = this.$lBg.find('.bg');
    this.$bgColumn = this.$lBg.find('.column');
    this.$bgImg = this.$bgColumn.find('.img');
    this.$bgNext = this.$bg.find('.next');
    this.$bgPrev = this.$bg.find('.prev');
    this.replaceImg = new ReplaceImg;
    this.tl = new TimelineMax;
    $(window).on('resize.animBg', (function(_this) {
      return function() {
        return _this.$bgImg.css({
          'width': $(window).width()
        });
      };
    })(this));
    $(window).resize();
  }

  AnimBg.prototype.set = function(src) {
    var _this;
    _this = this;
    return this.$bgImg.each(function() {
      return $(this).css({
        'background': "url(" + (_this.replaceImg.replace(src)) + ") no-repeat 50% 0",
        'background-size': 'cover'
      });
    });
  };

  AnimBg.prototype.show = function(src, func) {
    var _this, tl;
    _this = this;
    this.$bgPrev.css({
      'background': "url(" + (_this.replaceImg.replace(src)) + ") no-repeat 50% 0",
      'background-size': 'cover'
    });
    this.$bgImg.each(function() {
      return $(this).css({
        'background': "url(" + (_this.replaceImg.replace(src)) + ") no-repeat 50% 0",
        'background-size': 'cover'
      });
    });
    tl = new TimelineMax({
      onComplete: (function(_this) {
        return function() {
          _this.$bg.css({
            'display': 'block'
          });
          _this.$bgColumn.css({
            'display': 'none'
          });
          if (func != null) {
            return func();
          }
        };
      })(this)
    });
    tl.staggerFromTo(this.$bgImg, 1.25, {
      x: -_ww / 8 * 0.25
    }, {
      x: 0,
      ease: Power2.easeOut
    }, -0.075);
    return TweenMax.staggerFromTo(this.$bgImg, 0.5, {
      opacity: 0
    }, {
      opacity: 1,
      ease: Power2.easeOut
    }, -0.075);
  };

  AnimBg.prototype.hideStart = function(isLoad, func) {
    this.$bg.css({
      'display': 'none'
    });
    this.$bgColumn.css({
      'display': 'block'
    });
    this.tl.timeScale(1);
    this.tl.staggerTo(this.$bgImg, 0.75, {
      x: _ww / 8,
      ease: Power4.easeInOut
    }, 0.025);
    this.tl.addCallback((function(_this) {
      return function() {
        _this.tl.timeScale(0.5);
        return TweenMax.staggerTo(_this.$bgImg, 0.25, {
          opacity: 0,
          ease: Power1.easeOut
        }, 0.025);
      };
    })(this), 0.5);
    if (!isLoad) {
      return this.tl.addCallback((function(_this) {
        return function() {
          if (func != null) {
            return func();
          }
        };
      })(this), 0.75);
    }
  };

  AnimBg.prototype.hideEnd = function(func) {
    this.tl.clear();
    if (func != null) {
      return func();
    }
  };

  return AnimBg;

})();

AnimTitle = (function() {
  function AnimTitle($no, $en, $ja) {
    this.reset = bind(this.reset, this);
    this.animHide = bind(this.animHide, this);
    this.hide = bind(this.hide, this);
    this.animShow = bind(this.animShow, this);
    this.show = bind(this.show, this);
    this.$no = $no;
    this.$en = $en;
    this.$ja = $ja;
    this.$title = this.$no.add(this.$en).add(this.$ja);
  }

  AnimTitle.prototype.set = function(state, func) {
    var i, l, r, t;
    t = [];
    l = [];
    r = [];
    i = 0;
    this.reset(this.$no);
    this.reset(this.$en);
    this.reset(this.$ja);
    this.$title.children().andSelf().contents().each(function() {
      if (this.nodeType === 3) {
        return $(this).replaceWith($(this).text().replace(/(.)/g, '<span><span>$1</span></span>'));
      }
    });
    this.$title.children('span').each(function() {
      $(this).css({
        'display': 'inline-block',
        'overflow': 'hidden'
      });
      $(this).attr('data-width', $(this).width());
      l.push($(this).position().left);
      return r.push($(this).parent().width() - $(this).position().left - $(this).width());
    });
    this.$title.children('span').each(function() {
      var w;
      if (state === 'show') {
        w = 0;
      } else {
        w = $(this).data('width');
      }
      $(this).css({
        'width': w,
        'height': $(this).height(),
        'position': 'absolute',
        'top': t[i]
      });
      if (state === 'show') {
        $(this).css({
          'left': l[i],
          'right': 'auto'
        });
      } else if (state === 'hide') {
        $(this).css({
          'left': 'auto',
          'right': r[i]
        });
      }
      return i++;
    });
    this.$title.children('span').children('span').css({
      'display': 'block',
      'position': 'absolute',
      'top': 0
    });
    if (state === 'show') {
      this.$title.children('span').children('span').css({
        'left': 0
      });
    } else if (state === 'hide') {
      this.$title.children('span').children('span').css({
        'right': 0
      });
    }
    if (func != null) {
      return func();
    }
  };

  AnimTitle.prototype.show = function(func) {
    this.animShow(this.$no, 0);
    this.animShow(this.$en, 250);
    return this.animShow(this.$ja, 500, (function(_this) {
      return function() {
        if (func != null) {
          return func();
        }
      };
    })(this));
  };

  AnimTitle.prototype.animShow = function($dom, delay, func) {
    return setTimeout((function(_this) {
      return function() {
        $dom.children('span').each(function() {
          return $(this).css({
            'opacity': 0
          }).velocity({
            'opacity': [1, 'easeOutCubic'],
            'width': [$(this).data('width'), 'easeOutCubic']
          }, 1000, (function(_this) {
            return function() {};
          })(this));
        });
        return setTimeout(function() {
          if (func != null) {
            return func();
          }
        }, 1000);
      };
    })(this), delay);
  };

  AnimTitle.prototype.hide = function(func) {
    this.animHide(this.$no, 0);
    this.animHide(this.$en, 0);
    return this.animHide(this.$ja, 0, (function(_this) {
      return function() {
        if (func != null) {
          return func();
        }
      };
    })(this));
  };

  AnimTitle.prototype.animHide = function($dom, delay, func) {
    return setTimeout((function(_this) {
      return function() {
        $dom.children('span').each(function() {
          return $(this).css({
            'opacity': 1
          }).velocity({
            'opacity': [0, 'easeOutCubic'],
            'width': [0, 'easeOutCubic']
          }, 750);
        });
        return setTimeout(function() {
          if (func != null) {
            return func();
          }
        }, 750);
      };
    })(this), delay);
  };

  AnimTitle.prototype.reset = function($dom) {
    var str;
    str = '';
    if ($dom.children('span').length > 0) {
      $dom.children('span').each(function() {
        return str += $(this).text();
      });
      return $dom.html(str);
    }
  };

  return AnimTitle;

})();

ChangeBg = (function() {
  function ChangeBg() {
    this.off = bind(this.off, this);
    this.on = bind(this.on, this);
    this.$lBg = $('.l-bg');
    this.$bg = this.$lBg.find('.bg');
    this.$bgNext = this.$bg.find('.next');
    this.$bgPrev = this.$bg.find('.prev');
    this.replaceImg = new ReplaceImg();
  }

  ChangeBg.prototype.on = function() {
    var $endBg, _this, ary, ary2, l, p;
    _this = this;
    if ($('.m-end-bg').length > 0) {
      $endBg = $('.m-end-bg').eq(0);
    } else {
      $endBg = $('.l-footer');
    }
    p = 0.5;
    l = 0;
    ary = [];
    ary2 = {};
    ary2.t = $endBg.offset().top;
    ary2.isVisible = false;
    $('*[data-bg-src]').each(function() {
      var $dom, h, isVisible, src, t;
      $dom = $(this);
      t = $(this).offset().top;
      h = $(this).innerHeight();
      src = _this.replaceImg.replace($(this).data('bg-src'));
      isVisible = false;
      return ary.push({
        $dom: $dom,
        t: t,
        h: h,
        src: src,
        isVisible: isVisible
      });
    });
    ary[0].isVisible = true;
    this.$bgNext.css({
      'background': "url(" + ary[0].src + ") no-repeat 50% 0",
      'background-size': 'cover',
      'opacity': 1
    });
    this.$bgPrev.css({
      'background': "url(" + ary[0].src + ") no-repeat 50% 0",
      'background-size': 'cover',
      'opacity': 1
    });
    $(window).on('scroll.changeBg', (function(_this) {
      return function() {
        var i, j, results, s, src, val, val2;
        s = $(window).scrollTop();
        results = [];
        for (i in ary) {
          val = ary[i];
          if (i >= ary.length - 1) {
            l = _wh * p;
          } else {
            l = 0;
          }
          if (s + _wh * p > val.t && s + _wh * p + l < val.t + val.h && !val.isVisible) {
            for (j in ary) {
              val2 = ary[j];
              val2.isVisible = false;
            }
            val.isVisible = true;
            ary2.isVisible = false;
            src = val.src;
            _this.$bgNext.css({
              'background': "url(" + src + ") no-repeat 50% 0",
              'background-size': 'cover'
            });
            results.push(_this.$bgPrev.stop().velocity('stop').velocity({
              'opacity': 0
            }, 375, 'linear', function() {
              return _this.$bgPrev.css({
                'background': "url(" + src + ") no-repeat 50% 0",
                'background-size': 'cover',
                'opacity': 1
              });
            }));
          } else if (s + _wh > ary2.t && !ary2.isVisible) {
            for (j in ary) {
              val2 = ary[j];
              val2.isVisible = false;
            }
            ary2.isVisible = true;
            _this.$bgNext.css({
              'background': "#000"
            });
            results.push(_this.$bgPrev.stop().velocity('stop').velocity({
              'opacity': 0
            }, 375, 'linear', function() {
              return _this.$bgPrev.css({
                'background': "#000",
                'opacity': 1
              });
            }));
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
    })(this));
    return $(window).scroll();
  };

  ChangeBg.prototype.off = function() {
    $(window).off('scroll.changeBg');
    return this.$bg.css({
      'display': 'none'
    });
  };

  return ChangeBg;

})();

Transition = (function() {
  function Transition(animBg) {
    this.render = bind(this.render, this);
    this.fetch = bind(this.fetch, this);
    this.off = bind(this.off, this);
    this.on = bind(this.on, this);
    this.$body = $('body');
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    this.$lBg = $('.l-bg');
    this.$bg = this.$lBg.find('.bg');
    this.$bgColumn = this.$lBg.find('.column');
    this.$lFooter = $('.l-footer');
    this.$footerPagetop = this.$lFooter.find('.pagetop');
    this.animBg = animBg;
    this.tl = new TimelineMax;
  }

  Transition.prototype.on = function(init) {
    this.$lTitle = $('.l-title');
    this.$title = this.$lTitle.find('.title');
    this.$titleNo = this.$title.find('.no');
    this.$titleEn = this.$title.find('.en');
    this.$titleJa = this.$title.find('.ja span');
    this.$breadcrumb = this.$lTitle.find('.m-breadcrumb');
    this.$lMain = $('.l-main');
    this.$lFooter.css({
      'display': 'block'
    });
    this.$footerPagetop.css({
      'display': 'block'
    });
    this.animTitle = new AnimTitle(this.$titleNo, this.$titleEn, this.$titleJa);
    if (init != null) {
      this.animTitle.set('hide');
      this.$bgColumn.css({
        'display': 'none'
      });
      return this.animBg.set($('*[data-bg-src]').eq(0).data('bg-src'));
    } else {
      this.$title.css({
        'opacity': 0
      });
      this.$lMain.css({
        'opacity': 0
      });
      this.$breadcrumb.css({
        'opacity': 0
      });
      this.$bg.css({
        'display': 'none'
      });
      return this.$bgColumn.css({
        'display': 'block'
      });
    }
  };

  Transition.prototype.off = function() {};

  Transition.prototype.fetch = function() {
    this.$loaderProg.stop().velocity('stop').velocity({
      'width': ["50%", 'linear']
    }, 2000);
    this.$body.css({
      'overflow': 'hidden',
      'pointer-events': 'none'
    });
    $('html').velocity('scroll', 500, 'easeOutCubic');
    this.$lMain.velocity({
      'opacity': [0, 'easeOutCubic']
    }, 750);
    this.$breadcrumb.velocity({
      'opacity': [0, 'easeOutCubic']
    }, 750);
    this.animTitle.set('hide', (function(_this) {
      return function() {
        return _this.animTitle.hide();
      };
    })(this));
    return this.animBg.hideStart(true);
  };

  Transition.prototype.render = function() {
    return this.animBg.hideEnd((function(_this) {
      return function() {
        _this.$lMain.velocity({
          'opacity': [1, 'easeOutCubic']
        }, {
          duration: 750,
          delay: 1000
        });
        _this.$breadcrumb.velocity({
          'opacity': [1, 'easeOutCubic']
        }, {
          duration: 750,
          delay: 1000
        });
        _this.animTitle.set('show', function() {
          _this.$title.css({
            'opacity': 1
          });
          return _this.animTitle.show();
        });
        return setTimeout(function() {
          _this.$body.css({
            'overflow': 'visible'
          });
          $(window).off('.noScroll');
          return _this.animBg.show($('*[data-bg-src]').eq(0).data('bg-src'), function() {
            return _this.$body.css({
              'pointer-events': 'auto'
            });
          });
        }, 1125);
      };
    })(this));
  };

  return Transition;

})();

Header = (function() {
  function Header() {
    this.off = bind(this.off, this);
    this.on = bind(this.on, this);
    this.init = bind(this.init, this);
    this.$lHeader = $('.l-header');
    this.$nav = this.$lHeader.find('.nav');
    this.$navBtn = this.$nav.find('.btn');
    this.$navList = this.$nav.find('.list');
    this.$navListLi = this.$navList.find('li');
    this.$navBg = this.$nav.find('.bg');
  }

  Header.prototype.init = function() {
    var _this, isAnimate, l;
    _this = this;
    this.$navListLi.on('click', function() {
      return $(this).addClass('is-current-transition');
    });
    if (_sp) {
      l = this.$navListLi.length;
      isAnimate = false;
      return this.$navBtn.on('touchstart', (function(_this) {
        return function() {
          var i;
          if (!isAnimate) {
            isAnimate = true;
            if (!_this.$nav.hasClass('is-visible')) {
              _this.$nav.addClass('is-visible');
              _this.$navList.css({
                'display': 'block'
              });
              _this.$navListLi.css({
                'opacity': 0
              });
              i = 0;
              _this.$navListLi.each(function() {
                return $(this).velocity({
                  'opacity': 1
                }, {
                  duration: 375,
                  easing: 'easeOutCubic',
                  delay: 75 * i++
                });
              });
              setTimeout(function() {
                return isAnimate = false;
              }, 375 + 75 * l);
              return _this.$navBg.css({
                'display': 'block',
                'opacity': 0
              }).velocity({
                'opacity': 1
              }, 500, 'easeOutCubic');
            } else {
              _this.$nav.removeClass('is-visible');
              _this.$navListLi.velocity({
                'opacity': 0
              }, 500, 'easeOutCubic', function() {
                isAnimate = false;
                return _this.$navList.css({
                  'display': 'none'
                });
              });
              return _this.$navBg.velocity({
                'opacity': 0
              }, 500, 'easeOutCubic', function() {
                return _this.$navBg.css({
                  'display': 'none'
                });
              });
            }
          }
        };
      })(this));
    }
  };

  Header.prototype.on = function() {
    var $dir, $url;
    $url = location.href.split('/');
    $dir = $url[3];
    if (!$dir.match(/\?/)) {
      this.$navListLi.filter("." + $dir).addClass('is-current');
      return this.$navListLi.filter("." + $dir).removeClass('is-current-transition');
    }
  };

  Header.prototype.off = function() {
    return this.$navListLi.filter('.is-current').removeClass('is-current');
  };

  return Header;

})();

Footer = (function() {
  function Footer() {
    this.pagetop = bind(this.pagetop, this);
    this.init = bind(this.init, this);
    this.$lFooter = $('.l-footer');
  }

  Footer.prototype.init = function() {
    return this.pagetop();
  };

  Footer.prototype.pagetop = function() {
    var $pagetop;
    $pagetop = this.$lFooter.find('.pagetop');
    return $pagetop.on('click', function() {
      return $('html').velocity('scroll', 500, 'easeOutCubic');
    });
  };

  return Footer;

})();

Index = (function() {
  function Index(animBg) {
    this.render = bind(this.render, this);
    this.fetch = bind(this.fetch, this);
    this.setBlog = bind(this.setBlog, this);
    this.intro = bind(this.intro, this);
    this.setIntro = bind(this.setIntro, this);
    this.changePageNum = bind(this.changePageNum, this);
    this.preventDefault = bind(this.preventDefault, this);
    this.setDefault = bind(this.setDefault, this);
    this.setFix = bind(this.setFix, this);
    this.managePage = bind(this.managePage, this);
    this.off = bind(this.off, this);
    this.on = bind(this.on, this);
    var ref, ref1;
    this.$body = $('body');
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    this.$lHeader = $('.l-header');
    this.$lFooter = $('.l-footer');
    this.$footerPagetop = this.$lFooter.find('.pagetop');
    this.$lBg = $('.l-bg');
    this.$bg = this.$lBg.find('.bg');
    this.$bgColumn = this.$lBg.find('.column');
    this.$bgNext = this.$bg.find('.next');
    this.$bgPrev = this.$bg.find('.prev');
    this.e = (ref = indexOf.call(document, 'onwheel') >= 0) != null ? ref : {
      'wheel': (ref1 = indexOf.call(document, 'onmousewheel') >= 0) != null ? ref1 : {
        'mousewheel': 'DOMMouseScroll'
      }
    };
    this.replaceImg = new ReplaceImg;
    this.animBg = animBg;
    this.tl = new TimelineMax;
  }

  Index.prototype.on = function() {
    this.$lContents = $('.l-contents');
    this.$content = this.$lContents.find('.content');
    this.$lMain = $('.l-main');
    this.$lFix = this.$lContents.find('.l-fix');
    this.$lVisual = this.$lFix.find('.l-visual');
    this.$visualTitle = this.$lVisual.find('.title');
    this.$lDefault = this.$lContents.find('.l-default');
    this.$pages = this.$lContents.find('.pages');
    this.$pagesLi = this.$pages.find('li');
    this.isWheel = false;
    this.page = 0;
    this.prevPage = 0;
    this.$bgPrev.css({
      'background': "url(" + (this.replaceImg.replace(this.$lVisual.data('bg-src'))) + ") no-repeat 50% 0",
      'background-size': 'cover'
    });
    this.$pages.css({
      'display': 'none'
    });
    this.$lFooter.css({
      'display': 'none',
      'background': 'transparent'
    });
    this.$footerPagetop.css({
      'display': 'none'
    });
    this.setFix();
    return this.setBlog();
  };

  Index.prototype.off = function() {
    this.$lFix.off('mousewheel.fix DOMMouseScroll.fix');
    return $(window).off('scroll.default');
  };

  Index.prototype.managePage = function() {
    var $content, $prevContent, animTitle;
    $content = this.$content.filter(".c" + this.page);
    $prevContent = this.$content.filter(".c" + this.prevPage);
    this.$body.css({
      'pointer-events': 'none'
    });
    if (this.prevPage === 0 && this.page === 0) {
      this.isWheel = false;
      this.$body.css({
        'pointer-events': 'auto'
      });
    } else {
      this.changePageNum();
    }
    if (this.prevPage === 0 && this.page === 1) {
      $prevContent.velocity({
        'opacity': [0, 'easeOutSine']
      }, 500, (function(_this) {
        return function() {
          return $prevContent.css({
            'display': 'none'
          });
        };
      })(this));
      this.$lBg.velocity({
        'opacity': [0.2, 'easeOutSine']
      }, {
        duration: 500,
        delay: 375,
        mobileHA: false,
        complete: (function(_this) {
          return function() {
            return $content.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': [1, 'easeOutSine']
            }, {
              duration: 500,
              mobileHA: false,
              complete: function() {
                _this.isWheel = false;
                return _this.$body.css({
                  'pointer-events': 'auto'
                });
              }
            });
          };
        })(this)
      });
    }
    if (this.prevPage === 1 && this.page === 0) {
      $prevContent.velocity({
        'opacity': [0, 'easeOutSine']
      }, {
        duration: 500,
        mobileHA: false,
        complete: (function(_this) {
          return function() {
            return $prevContent.css({
              'display': 'none'
            });
          };
        })(this)
      });
      this.$lBg.velocity({
        'opacity': [1, 'linear']
      }, {
        duration: 500,
        delay: 375,
        mobileHA: false,
        complete: (function(_this) {
          return function() {
            return $content.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': [1, 'easeOutSine']
            }, 500, function() {
              _this.isWheel = false;
              return _this.$body.css({
                'pointer-events': 'auto'
              });
            });
          };
        })(this)
      });
    }
    if (this.prevPage === 1 && this.page === 2) {
      $prevContent.velocity({
        'opacity': [0, 'easeOutSine']
      }, {
        duration: 500,
        mobileHA: false
      });
      this.animBg.hideStart(false, (function(_this) {
        return function() {
          return _this.animBg.hideEnd(function() {
            _this.$lBg.css({
              'opacity': 1
            });
            _this.animBg.show($content.data('bg-src'));
            return setTimeout(function() {
              var animTitle;
              $content.css({
                'display': 'block',
                'opacity': 1
              });
              animTitle = new AnimTitle($content.find('.title .no'), $content.find('.title .en'), $content.find('.title .ja > span'));
              animTitle.set('show', function() {
                return animTitle.show();
              });
              return $content.find('.inner').css({
                'opacity': 0
              }).velocity({
                'opacity': [1, 'easeOutSine']
              }, {
                duration: 375,
                delay: 750,
                complete: function() {
                  _this.isWheel = false;
                  return _this.$body.css({
                    'pointer-events': 'auto'
                  });
                }
              });
            }, 750);
          });
        };
      })(this));
    }
    if (this.prevPage === 2 && this.page === 1) {
      animTitle = new AnimTitle($prevContent.find('.title .no'), $prevContent.find('.title .en'), $prevContent.find('.title .ja > span'));
      animTitle.set('hide', (function(_this) {
        return function() {
          return animTitle.hide();
        };
      })(this));
      $prevContent.find('.inner').velocity({
        'opacity': [0, 'easeOutSine']
      }, 500, (function(_this) {
        return function() {
          return $prevContent.css({
            'display': 'none'
          });
        };
      })(this));
      this.animBg.hideStart(false, (function(_this) {
        return function() {
          return _this.animBg.hideEnd(function() {
            $content.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': [1, 'easeOutSine']
            }, {
              duration: 500,
              mobileHA: false
            });
            _this.$lBg.css({
              'opacity': 0.2
            });
            return _this.animBg.show($content.data('bg-src'), function() {
              _this.isWheel = false;
              return _this.$body.css({
                'pointer-events': 'auto'
              });
            });
          });
        };
      })(this));
    }
    if (this.prevPage === 2 && this.page === 3 || this.prevPage === 3 && this.page === 2) {
      animTitle = new AnimTitle($prevContent.find('.title .no'), $prevContent.find('.title .en'), $prevContent.find('.title .ja > span'));
      animTitle.set('hide', (function(_this) {
        return function() {
          return animTitle.hide();
        };
      })(this));
      $prevContent.find('.inner').velocity({
        'opacity': [0, 'easeOutSine']
      }, 500, (function(_this) {
        return function() {
          return $prevContent.css({
            'display': 'none'
          });
        };
      })(this));
      this.animBg.hideStart(false, (function(_this) {
        return function() {
          return _this.animBg.hideEnd(function() {
            _this.$lBg.css({
              'opacity': 1
            });
            _this.animBg.show($content.data('bg-src'), function() {});
            return setTimeout(function() {
              $content.css({
                'display': 'block',
                'opacity': 1
              });
              animTitle = new AnimTitle($content.find('.title .no'), $content.find('.title .en'), $content.find('.title .ja > span'));
              animTitle.set('show', function() {
                return animTitle.show();
              });
              return $content.find('.inner').css({
                'opacity': 0
              }).velocity({
                'opacity': [1, 'easeOutSine']
              }, {
                duration: 375,
                delay: 750,
                complete: function() {
                  _this.isWheel = false;
                  return _this.$body.css({
                    'pointer-events': 'auto'
                  });
                }
              });
            }, 750);
          });
        };
      })(this));
    }
    if (this.prevPage === 3 && this.page === 4) {
      this.preventDefault('on');
      animTitle = new AnimTitle($prevContent.find('.title .no'), $prevContent.find('.title .en'), $prevContent.find('.title .ja > span'));
      animTitle.set('hide', (function(_this) {
        return function() {
          return animTitle.hide();
        };
      })(this));
      $prevContent.find('.inner').velocity({
        'opacity': [0, 'easeOutSine']
      }, 500, (function(_this) {
        return function() {
          return $prevContent.css({
            'display': 'none'
          });
        };
      })(this));
      this.animBg.hideStart(false, (function(_this) {
        return function() {
          return _this.animBg.hideEnd(function() {
            _this.$lBg.css({
              'opacity': 1
            });
            _this.animBg.show($content.data('bg-src'));
            return setTimeout(function() {
              _this.$lDefault.css({
                'opacity': 0,
                'display': 'block'
              });
              $content.css({
                'display': 'block',
                'opacity': 1
              });
              animTitle = new AnimTitle($content.find('.title .no'), $content.find('.title .en'), $content.find('.title .ja > span'));
              animTitle.set('show', function() {
                _this.$lDefault.css({
                  'opacity': 1
                });
                return animTitle.show();
              });
              return $content.find('.inner').css({
                'opacity': 0
              }).velocity({
                'opacity': [1, 'easeOutSine']
              }, {
                duration: 500,
                delay: 750,
                complete: function() {
                  _this.$lContents.css({
                    'height': 'auto'
                  });
                  _this.$lFix.css({
                    'display': 'none'
                  });
                  _this.$lFooter.css({
                    'display': 'block'
                  });
                  _this.$body.css({
                    'pointer-events': 'auto'
                  });
                  return _this.setDefault();
                }
              });
            }, 750);
          });
        };
      })(this));
    }
    if (this.prevPage === 4 && this.page === 3) {
      this.preventDefault('on');
      $(window).off('scroll.default');
      animTitle = new AnimTitle($prevContent.find('.title .no'), $prevContent.find('.title .en'), $prevContent.find('.title .ja > span'));
      animTitle.set('hide', (function(_this) {
        return function() {
          return animTitle.hide();
        };
      })(this));
      $prevContent.find('.inner').velocity({
        'opacity': [0, 'easeOutSine']
      }, 500);
      return this.animBg.hideStart(false, (function(_this) {
        return function() {
          return _this.animBg.hideEnd(function() {
            _this.$lContents.css({
              'height': '100%'
            });
            _this.$lFix.css({
              'display': 'block'
            });
            _this.$lDefault.css({
              'display': 'none'
            });
            _this.$lFooter.css({
              'display': 'none'
            });
            _this.$lBg.css({
              'opacity': 1
            });
            _this.animBg.show($content.data('bg-src'), function() {});
            return setTimeout(function() {
              $content.css({
                'display': 'block',
                'opacity': 1
              });
              animTitle = new AnimTitle($content.find('.title .no'), $content.find('.title .en'), $content.find('.title .ja > span'));
              animTitle.set('show', function() {
                return animTitle.show();
              });
              return $content.find('.inner').css({
                'opacity': 0
              }).velocity({
                'opacity': [1, 'easeOutSine']
              }, {
                duration: 375,
                delay: 750,
                complete: function() {
                  _this.preventDefault('off');
                  _this.isWheel = false;
                  return _this.$body.css({
                    'pointer-events': 'auto'
                  });
                }
              });
            }, 750);
          });
        };
      })(this));
    }
  };

  Index.prototype.setFix = function() {
    var d, m, p;
    if (!_sp) {
      return this.$lFix.on('mousewheel.fix DOMMouseScroll.fix', (function(_this) {
        return function(e) {
          if (!_this.isWheel) {
            _this.isWheel = true;
            if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
              _this.prevPage = _this.page;
              if (_this.page > 0) {
                _this.page--;
              }
            } else {
              _this.prevPage = _this.page;
              if (_this.page < 5) {
                _this.page++;
              }
            }
            return _this.managePage();
          }
        };
      })(this));
    } else {
      p = 0;
      d = '';
      m = false;
      this.$lFix.on('touchstart.fix', (function(_this) {
        return function(e) {
          p = e.originalEvent.touches[0].pageY;
          return d = '';
        };
      })(this));
      this.$lFix.on('touchmove.fix', (function(_this) {
        return function(e) {
          if (p - e.originalEvent.touches[0].pageY > 50) {
            d = 'up';
            m = true;
          } else if (p - e.originalEvent.touches[0].pageY < -50) {
            d = 'down';
            m = true;
          }
          return e.preventDefault();
        };
      })(this));
      return this.$lFix.on('touchend.fix', (function(_this) {
        return function(e) {
          if (m) {
            m = false;
            if (!_this.isWheel) {
              _this.isWheel = true;
              if (d === 'down') {
                _this.prevPage = _this.page;
                if (_this.page > 0) {
                  _this.page--;
                }
              } else if (d === 'up') {
                _this.prevPage = _this.page;
                if (_this.page < 5) {
                  _this.page++;
                }
              }
              return _this.managePage();
            }
          }
        };
      })(this));
    }
  };

  Index.prototype.setDefault = function() {
    var ary;
    this.page = 4;
    ary = [];
    $(window).scrollTop(1);
    this.$lDefault.find('.content').each(function() {
      var $dom, h, isVisible, page, t;
      $dom = $(this);
      t = $(this).offset().top;
      h = $(this).innerHeight();
      page = $(this).index() + 4;
      isVisible = false;
      return ary.push({
        $dom: $dom,
        t: t,
        h: h,
        page: page,
        isVisible: isVisible
      });
    });
    return setTimeout((function(_this) {
      return function() {
        _this.preventDefault('off');
        return $(window).on('scroll.default', function() {
          var i, j, results, s, val, val2;
          s = $(window).scrollTop();
          if (s <= 0) {
            _this.prevPage = 4;
            _this.page = 3;
            return _this.managePage();
          } else {
            results = [];
            for (i in ary) {
              val = ary[i];
              if (s + _wh > val.t && s + _wh < val.t + val.h && !val.isVisible) {
                for (j in ary) {
                  val2 = ary[j];
                  val2.isVisible = false;
                }
                val.isVisible = true;
                _this.prevPage = _this.page;
                _this.page = val.page;
                if (_this.page === 4) {
                  _this.$lBg.stop().velocity('stop').velocity({
                    'opacity': [1, 'linear']
                  }, {
                    duration: 375,
                    mobileHA: false
                  });
                } else if (_this.page === 5) {
                  _this.$lBg.stop().velocity('stop').velocity({
                    'opacity': [0, 'linear']
                  }, {
                    duration: 375,
                    mobileHA: false
                  });
                }
                results.push(_this.changePageNum());
              } else {
                results.push(void 0);
              }
            }
            return results;
          }
        });
      };
    })(this), 100);
  };

  Index.prototype.preventDefault = function(s) {
    var scrollEvent;
    scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
    if (s === 'on') {
      return $(document).on(scrollEvent, function(e) {
        return e.preventDefault();
      });
    } else if (s === 'off') {
      return $(document).off(scrollEvent);
    }
  };

  Index.prototype.changePageNum = function() {
    this.$pagesLi.removeClass('is-current');
    if (this.page > 0) {
      return this.$pagesLi.eq(this.page - 1).addClass('is-current');
    }
  };

  Index.prototype.setIntro = function() {
    this.$lContents = $('.l-contents');
    this.$content = this.$lContents.find('.content');
    this.$lFix = this.$lContents.find('.l-fix');
    this.$lVisual = this.$lFix.find('.l-visual');
    this.$lDefault = this.$lContents.find('.l-default');
    this.$pages = this.$lContents.find('.pages');
    this.$pagesLi = this.$pages.find('li');
    this.$visualTitle = this.$lVisual.find('.title');
    this.$visualTitleEn = this.$lVisual.find('.en');
    this.$visualTitleJa = this.$lVisual.find('.ja');
    this.$visualArrow = this.$lVisual.find('.arrow');
    this.$lBg = $('.l-bg');
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    if (!_sp) {
      this.video = new Video(this.$visualTitle.find('canvas'), [_templateUrl + "/assets/images/pc/index/h_title_anim.png"], 2020, 496);
    } else {
      this.video = new Video(this.$visualTitle.find('canvas'), [_templateUrl + "/assets/images/sp/index/h_title_anim_1.png", _templateUrl + "/assets/images/sp/index/h_title_anim_2.png", _templateUrl + "/assets/images/sp/index/h_title_anim_3.png", _templateUrl + "/assets/images/sp/index/h_title_anim_4.png"], 600, 147);
    }
    this.$lHeader.css({
      'display': 'none'
    });
    this.$lFooter.css({
      'display': 'none'
    });
    this.$lVisual.css({
      'display': 'block'
    });
    this.$lBg.css({
      'display': 'none'
    });
    this.$pages.css({
      'display': 'none'
    });
    this.$visualTitle.css({
      'background': 'none'
    });
    this.$visualTitleEn.css({
      'opacity': 0
    });
    this.$visualTitleJa.css({
      'opacity': 0
    });
    this.$visualArrow.css({
      'opacity': 0
    });
    return this.$loaderProg.stop().velocity('stop').velocity({
      'width': ["50%", 'linear']
    }, 2000);
  };

  Index.prototype.intro = function() {
    var enLetterSpacing, jaLetterSpacing;
    enLetterSpacing = this.$visualTitleEn.css('letter-spacing');
    jaLetterSpacing = this.$visualTitleJa.css('letter-spacing');
    this.video.play();
    this.animBg.set(this.$lVisual.data('bg-src'));
    return setTimeout((function(_this) {
      return function() {
        _this.$lBg.css({
          'display': 'block',
          'opacity': 0
        }).velocity({
          'opacity': [1, 'linear']
        }, {
          duration: 2000,
          mobileHA: false
        });
        _this.$visualTitleEn.css({
          'letter-spacing': '-0.5em'
        }).velocity({
          'opacity': [1, 'easeInCubic'],
          'letter-spacing': [enLetterSpacing, 'easeInOutExpo']
        }, 2000);
        return _this.$visualTitleJa.css({
          'letter-spacing': '-0.75em'
        }).velocity({
          'opacity': [1, 'easeInQuart'],
          'letter-spacing': [jaLetterSpacing, 'easeInOutExpo']
        }, {
          duration: 2000,
          delay: 500,
          complete: function() {
            _this.on();
            _this.$bg.css({
              'display': 'block'
            });
            _this.$bgColumn.css({
              'display': 'none'
            });
            _this.$lHeader.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': 1
            }, 500, 'easeOutCubic');
            _this.$pages.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': 1
            }, 500, 'easeOutCubic');
            return _this.$visualArrow.velocity({
              'opacity': 1
            }, 500, 'easeOutCubic');
          }
        });
      };
    })(this), 2500);
  };

  Index.prototype.setBlog = function() {
    var $item, $lBlog, $next, $page, $prev, change, isAnimate, length, page;
    $lBlog = $('.l-blog');
    $item = $lBlog.find('.item');
    $prev = $lBlog.find('.prev');
    $next = $lBlog.find('.next');
    $page = $lBlog.find('.slide-nav .page');
    page = 0;
    length = $item.length - 1;
    isAnimate = false;
    change = (function(_this) {
      return function(direction) {
        var course;
        isAnimate = true;
        if (direction === 'left') {
          course = -1;
        } else {
          course = 1;
        }
        $page.removeClass('is-current');
        $page.eq(page).addClass('is-current');
        $item.filter('.is-current').velocity({
          'opacity': [0, 'easeOutCubic'],
          'translateX': [(32 * course) + "px", 'easeOutCubic']
        }, 375, function() {
          return $(this).removeClass('is-current').velocity({
            'translateX': 0
          }, 0);
        });
        return setTimeout(function() {
          return $item.eq(page).velocity({
            'opacity': 0,
            'translateX': (-32 * course) + "px"
          }, 0, function() {
            return $(this).addClass('is-current').velocity({
              'opacity': [1, 'easeOutCubic'],
              'translateX': [0, 'easeOutCubic']
            }, 500, function() {
              return isAnimate = false;
            });
          });
        }, 250);
      };
    })(this);
    $prev.on('click', (function(_this) {
      return function() {
        if (!isAnimate) {
          if (page > 0) {
            page--;
          } else {
            page = length;
          }
          return change('left');
        }
      };
    })(this));
    return $next.on('click', (function(_this) {
      return function() {
        if (!isAnimate) {
          if (page < length) {
            page++;
          } else {
            page = 0;
          }
          return change('right');
        }
      };
    })(this));
  };

  Index.prototype.fetch = function() {
    this.$loaderProg.stop().velocity('stop').velocity({
      'width': ["50%", 'linear']
    }, 2000);
    this.$body.css({
      'overflow': 'hidden',
      'pointer-events': 'none'
    });
    $('html').velocity('scroll', 500, 'easeOutCubic');
    this.$lMain.velocity({
      'opacity': [0, 'easeOutCubic']
    }, 750);
    this.$lBg.velocity({
      'opacity': [1, 'easeOutCubic']
    }, 750);
    return this.animBg.hideStart(true);
  };

  Index.prototype.render = function() {
    this.isWheel = true;
    return this.animBg.hideEnd((function(_this) {
      return function() {
        return setTimeout(function() {
          _this.$body.css({
            'overflow': 'visible'
          });
          $(window).off('.noScroll');
          return _this.animBg.show($('*[data-bg-src]').eq(0).data('bg-src'), function() {
            _this.$pages.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': 1
            }, 500, 'easeOutCubic');
            return _this.$lVisual.css({
              'display': 'block',
              'opacity': 0
            }).velocity({
              'opacity': [1, 'easeOutSine']
            }, 500, function() {
              _this.isWheel = false;
              return _this.$body.css({
                'pointer-events': 'auto'
              });
            });
          });
        }, 500);
      };
    })(this));
  };

  return Index;

})();

InitPc = (function() {
  function InitPc() {
    this.init = bind(this.init, this);
    this.off = bind(this.off, this);
    this.on = bind(this.on, this);
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    this.load = new Load;
    this.replaceImg = new ReplaceImg;
    this.animBg = new AnimBg;
    this.changeBg = new ChangeBg;
    this.transition = new Transition(this.animBg);
    this.header = new Header;
    this.footer = new Footer;
    this.index = new Index(this.animBg);
  }

  InitPc.prototype.on = function() {
    var $lContents, imgs;
    $lContents = $('.l-contents');
    imgs = this.load.searchImgSrc($('*'));
    if ($lContents.hasClass('index')) {
      this.index.on();
    } else {
      this.header.on();
      this.transition.on();
      this.slider = new Slider;
      this.slider.set();
      if ($('.m-accordion').length > 0) {
        new Accordion($('.m-accordion-trigger'));
      }
      new TabChange;
      new ZipInput;
      new DisableSendBtn;
      this.changeBg.on();
    }
    return this.load.load(imgs, (function(_this) {
      return function() {
        _this.replaceImg.set($('img'));
        if ($lContents.hasClass('index')) {
          return _this.index.render();
        } else {
          return _this.transition.render();
        }
      };
    })(this));
  };

  InitPc.prototype.off = function() {
    var $lContents;
    $lContents = $('.l-contents');
    if ($lContents.hasClass('index')) {
      this.index.off();
      return this.index.fetch();
    } else {
      this.header.off();
      this.changeBg.off();
      this.transition.off();
      return this.transition.fetch();
    }
  };

  InitPc.prototype.init = function() {
    var $lContents, imgs;
    $lContents = $('.l-contents');
    imgs = this.load.searchImgSrc($('*'));
    this.header.init();
    this.footer.init();
    this.$loaderBg.css({
      'opacity': 1
    });
    if ($lContents.hasClass('index')) {
      this.index.setIntro();
      imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title.svg");
    } else {
      this.header.on();
      this.transition.on();
      this.slider = new Slider;
      this.slider.set();
      if ($('.m-accordion').length > 0) {
        new Accordion($('.m-accordion-trigger'));
      }
      new TabChange;
      new ZipInput;
      new DisableSendBtn;
      this.changeBg.on();
    }
    return this.load.load(imgs, (function(_this) {
      return function() {
        _this.load.initComp();
        _this.replaceImg.set($('img'));
        if ($lContents.hasClass('index')) {
          return _this.index.intro();
        } else {
          return _this.transition.render();
        }
      };
    })(this));
  };

  return InitPc;

})();

InitSp = (function() {
  function InitSp() {
    this.init = bind(this.init, this);
    this.$lLoader = $('.l-loader');
    this.$loaderProg = this.$lLoader.find('.prog');
    this.$loaderBg = this.$lLoader.find('.bg');
    this.load = new Load;
    this.replaceImg = new ReplaceImg;
    this.animBg = new AnimBg;
    this.changeBg = new ChangeBg;
    this.transition = new Transition(this.animBg);
    this.slider = new Slider;
    this.header = new Header;
    this.footer = new Footer;
    this.index = new Index(this.animBg);
  }

  InitSp.prototype.init = function() {
    var $lContents, imgs;
    $lContents = $('.l-contents');
    imgs = this.load.searchImgSrc($('*'));
    this.header.init();
    this.footer.init();
    this.$loaderBg.css({
      'opacity': 1
    });
    if ($('.m-accordion').length > 0) {
      new Accordion($('.m-accordion-trigger'));
    }
    if ($lContents.hasClass('index')) {
      this.index.setIntro();
      if (!_sp) {
        imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title_anim.png");
      } else {
        imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title_anim_1.png");
        imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title_anim_2.png");
        imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title_anim_3.png");
        imgs.push(_templateUrl + "/assets/images/" + _device + "/index/h_title_anim_4.png");
      }
    } else {
      this.header.on();
      this.changeBg.on();
      this.transition.on();
      this.slider.set();
      new TabChange;
      new ZipInput;
      new DisableSendBtn;
    }
    return this.load.load(imgs, (function(_this) {
      return function() {
        _this.load.initComp();
        _this.replaceImg.set($('img'));
        if ($lContents.hasClass('index')) {
          return _this.index.intro();
        } else {
          return _this.transition.render();
        }
      };
    })(this));
  };

  return InitSp;

})();

$(function() {
  var init;
  if (!_sp) {
    init = new InitPc;
    init.init();
    $.pjax({
      area: '.l-contents',
      load: {
        head: 'base,meta,link'
      },
      link: 'a:not([target]):not([href=""])',
      ajax: {
        timeout: 10000
      },
      wait: 750
    });
    $(document).on('pjax:fetch', function() {
      return init.off();
    });
    return $(document).on('pjax:render', function() {
      return init.on();
    });
  } else {
    init = new InitSp;
    return init.init();
  }
});

//# sourceMappingURL=data:application/json;base64,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
